import React from "react";
import { observer } from "mobx-react";
import { SnapshotOverrideViewStore } from "../../store";
import { SnapshotOverrideViewForm } from "./SnapshotOverrideViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type SnapshotOverrideViewProps = {
  snapshotOverrideViewStore: SnapshotOverrideViewStore;
};

export const SnapshotOverrideView: React.FC<SnapshotOverrideViewProps> =
  observer(({ snapshotOverrideViewStore }) => {
    return (
      <div>
        <SnapshotOverrideViewForm
          relatedEntityType={snapshotOverrideViewStore.relatedEntityTypeValue}
          relatedEntityId={snapshotOverrideViewStore.relatedEntityIdValue}
          path={snapshotOverrideViewStore.pathValue}
          value={snapshotOverrideViewStore.valueValue}
          note={snapshotOverrideViewStore.noteValue}
          active={snapshotOverrideViewStore.activeValue}
          onPrint={(handlePrint: () => void) =>
            snapshotOverrideViewStore.printSnapshotOverride(handlePrint)
          }
          onCancel={() => snapshotOverrideViewStore.cancelSnapshotOverride()}
          onEdit={
            snapshotOverrideViewStore.isEditEnabled
              ? () => snapshotOverrideViewStore.editSnapshotOverride()
              : undefined
          }
        />
        <ErrorDialog
          open={snapshotOverrideViewStore.errorDialogOpened}
          title={snapshotOverrideViewStore.errorTitle}
          description={snapshotOverrideViewStore.errorDescription}
          onClose={() => snapshotOverrideViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
